import React from 'react';
import './Introduction.css';
import { BsFillGridFill, BsFillInboxesFill } from "react-icons/bs";
import { AiTwotoneSetting, AiTwotoneRocket} from "react-icons/ai"
import { FaCheck} from "react-icons/fa";
import { IoMdAnalytics } from "react-icons/io";
import { SiMaterialdesign } from "react-icons/si";
import { RiBuilding3Fill } from "react-icons/ri";
import { Link } from 'react-router-dom';



const Introduction = () => {


 return (
  <>
  <div className="container mt-5">
 <div className="row">
 <div className="col-md-6">
 <div className="intro">
 <p className="text-dark">
 Software House
 </p>
 <h2 className="text-dark">
 Introduce your business using software
 </h2>
 <p className="text-dark">
 Lorem ipsum dolor sit amet consectetur adipisicing elit. Dolorem cumque deserunt culpa ex debitis incidunt ab.
 </p>
 <Link to="/services" className="btn btn-primary">Know more</Link>
 </div>
 </div>
 <div className="col-md-6">
 <div className="img-container">
      <img src="https://res.cloudinary.com/www-daniekeys-com/image/upload/v1605272119/background1_tonejn.png" className="img-responsive" alt="" />
 </div>
 </div>
 </div>
  </div>
  <div className="container mt-5">
  <div className="about-info-header">
  <h6 className="text-primary">
  Best Software
  </h6>
  <h2 className="text-dark">
  Why choose us
  </h2>
  </div>
   <div className="about-info-content mt-4">
 <div className="row">
 <div className="col-md-6">
 <div className="container">
 <div className="row">
 <div className="col-xs-2">
          < BsFillGridFill  className="text-primary  icon" />
 </div>
 <div className="col">
 <h4 className="text-dark my-2 about-topic">
 Elegant and Modern Design
 </h4>
 <p className="text-dark">
The designs we make are designs that are trending. Our Team makes sure your website always looks good
</p>
 </div>
 </div>
 </div>
 </div>
 <div className="col-md-6">
 <div className="container">
 <div className="row">
 <div className="col-xs-2">
          < BsFillInboxesFill  className="text-primary  icon" />
 </div>
 <div className="col">
 <h4 className="text-dark my-2 about-topic">
 Your Data is Safe
 </h4>
 <p className="text-dark">
Here at our company our users data is treated as highly confidential material , so because of that we ar using a well protected database so you dont have to worry about your data getting lost. 
</p>
 </div>
 </div>
 </div>
 </div>
 <div className="col-md-6">
 <div className="container">
 <div className="row">
 <div className="col-xs-2">
          <  AiTwotoneSetting  className="text-primary  icon" />
 </div>
 <div className="col">
 <h4 className="text-dark my-2 about-topic">
 High Elegant Analysis
 </h4>
 <p className="text-dark">
 Our system is design in such a way that it gives our dear esteemed customers anaylytical feedback on how thier website is doing online.
 </p>
 </div>
 </div>
 </div>
 </div>
 <div className="col-md-6">
 <div className="container">
 <div className="row">
 <div className="col-xs-2">
          < AiTwotoneRocket  className="text-primary  icon" />
 </div>
 <div className="col">
 <h4 className="text-dark my-2 about-topic">
 Our Dedicated Support
 </h4>
 <p className="text-dark">
We understand the fact that sometimes our users might faces some challenges using our products , so that is why we have a 24/7 support system to help our users. 
</p>
 </div>
 </div>
 </div>
 </div>

 </div>
    </div>
  </div>
  <div className="container mt-5">
  <div className="row">
  <div className="col-md-6">
      <div className="img-container mb-4">
       <img src="https://res.cloudinary.com/www-daniekeys-com/image/upload/v1605272119/background1_tonejn.png" className="img-responsive" alt="" />
      </div>
  </div>
  <div className="col-md-6">
   <div className="packages container">
   <h2 className="text-dark">
   Get the best package for your business
   </h2>
   <div className="underline bg-primary"></div>
   <p className="text-dark mt-3">
   We work systematically to integrate cooporate responsibility in our core business and make our experience available for the benefit of the societies where we operate.
   </p>
   <div className="row my-1">
 <div className="col-xs-2">
         <FaCheck  className="text-primary mark" />
 </div>
    <div className="col">
      <p className="text-dark">
      Application that is easy to use for users to understand
      </p>
      </div>
   </div>
   <div className="row my-1">
 <div className="col-xs-2">
         <FaCheck  className="text-primary mark" />
 </div>
    <div className="col">
      <p className="text-dark">
      We have supported libraries need
      </p>
      </div>
   </div>
   <div className="row my-1">
 <div className="col-xs-2">
         <FaCheck  className="text-primary mark" />
 </div>
    <div className="col">
      <p className="text-dark">
     Perfect for sites or agencies that manage many clients
      </p>
      </div>
   </div>
   <Link to="/services" className="btn btn-primary">Check  out </Link>
   </div>
  </div>
  </div>
  </div>
  <div className="container-fluid work p-4">
  <div className="container ">
  <div className="work-title">
  
   <p className="text-primary text-center work-text">
   Work Flow
   </p>
   <h2 className="text-center text-dark work-text mb-3">
   Our Working Process
   </h2>
  </div>
  <div className="work-process container">
  <div className="row">
  <div className="col-md-6">
  <div className="row">
  <div className="col my-2">
  
  <div className="circle">
         < BsFillGridFill className="text-primary  icon" />
  </div>
  <h6 className="text-dark text-center mt-3 work-text">
  Planning
  </h6>
  </div>
  <div className="col my-2">
  
  <div className="circle">
           < IoMdAnalytics className="text-primary  icon" />
  </div>
  <h6 className="text-dark text-center mt-3 work-text">
  Analysis
  </h6>
  </div>
  </div>
  </div>
  <div className="col-md-6">
  <div className="row">
  <div className="col my-2">
  
  <div className="circle">
           < SiMaterialdesign className="text-primary  icon" />
  </div>
  <h6 className="text-dark text-center mt-3 work-text">
  Design
  </h6>
  </div>
  <div className="col my-2">
  
  <div className="circle">
           < RiBuilding3Fill className="text-primary  icon" />
  </div>
  <h6 className="text-dark text-center mt-3 work-text">
  Development
  </h6>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>
  </>
 
 )
}
export default Introduction 